import { ApiResponse } from "@/types";
import { apiSlice } from "@/redux/apiSlice";
import {
  SaleTaxTable,
  SaleTax as SaleTaxType,
} from "@/types/system-setting/sale-tax";
import { TaxGroup, TaxGroupTable } from "@/types/system-setting/tax-group";

export const SalesTax = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getSalesTax: builder.query<
        SaleTaxTable,
        {
          query: string;
          org_id: number;
        }
      >({
        query: (searchCretiria) => ({
          url: `/sale_taxes?org_id=${searchCretiria.org_id}&${searchCretiria.query}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      createSalesTax: builder.mutation<ApiResponse, SaleTaxType>({
        query: (saleTaxesdata) => ({
          url: `/sale_taxes`,
          method: "POST",
          body: saleTaxesdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      updateSalesTax: builder.mutation<ApiResponse, SaleTaxType>({
        query: (saleTaxesdata) => ({
          url: `/sale_taxes/${saleTaxesdata.id}`,
          method: "PUT",
          body: saleTaxesdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      deleteSalesTax: builder.mutation<ApiResponse, number>({
        query: (sale_tax_id) => ({
          url: `/sale_taxes/${sale_tax_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      getSalesTaxById: builder.query<SaleTaxType, { sale_tax_id: number; orgId: number }>({
        query: ({ sale_tax_id, orgId }) => ({
          url: `/sale_taxes/${sale_tax_id}?org_id=${orgId}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),
      getSalesTaxList: builder.query<
        {
          id: number;
          name: string;
          percentage: number;
        }[],
        number
      >({
        query: (org_id) => ({
          url: `/sale_taxes/list/`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships"],
      }),

      // Tax Group
      getTaxGroup: builder.query<TaxGroupTable, { query: string, org_id: number }>({
        query: (searchCretiria) => ({
          url: `/tax_group?org_id=${searchCretiria.org_id}${searchCretiria.query.length > 0 ? `&${searchCretiria.query}` : ''}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships","Members","Product","Facility","Invoice","Transaction"],
      }),
      createTaxGroup: builder.mutation<ApiResponse, TaxGroup>({
        query: (taxGroupdata) => ({
          url: `/tax_group`,
          method: "POST",
          body: taxGroupdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships","Members","Product","Facility","Invoice","Transaction"],
      }),
      updateTaxGroup: builder.mutation<ApiResponse, TaxGroup>({
        query: (taxGroupdata) => ({
          url: `/tax_group/${taxGroupdata.id}`,
          method: "PUT",
          body: taxGroupdata,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships","Members","Product","Facility","Invoice","Transaction"],
      }),
      deleteTaxGroup: builder.mutation<ApiResponse, number>({
        query: (tax_group_id) => ({
          url: `/tax_group/${tax_group_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["SalesTax", "IncomeCategory", "Memberships","Members","Product","Facility","Invoice","Transaction"],
      }),
      getTaxGroupById: builder.query<TaxGroup, { tax_group_id: number, orgId: number }>({
        query: ({ tax_group_id, orgId }) => ({
          url: `/tax_group/${tax_group_id}?org_id=${orgId}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["SalesTax", "IncomeCategory", "Memberships","Members","Product","Facility","Invoice","Transaction"],
      }),
    };
  },
});

export const {
  useGetSalesTaxQuery,
  useCreateSalesTaxMutation,
  useUpdateSalesTaxMutation,
  useDeleteSalesTaxMutation,
  useGetSalesTaxByIdQuery,
  useLazyGetSalesTaxByIdQuery,
  useGetSalesTaxListQuery,

  // Tax Group
  useGetTaxGroupQuery,
  useCreateTaxGroupMutation,
  useUpdateTaxGroupMutation,
  useDeleteTaxGroupMutation,
  useGetTaxGroupByIdQuery,
} = SalesTax;
